import { NgModule } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApplicationsPatientListComponent } from './pages/applications-patients-list/applications-patients-list.component';
import { ApplicationsComponent } from './pages/applications/applications.component';
import { ApplicationsPatientProfileComponent } from './pages/applications-patient-profile/applications-patient-profile.component';
import { SharedModule } from '../../shared/shared.module';
import { ApplicationsRouterModule } from './applications.-route.module';

@NgModule({
  declarations: [
    ApplicationsComponent,
    ApplicationsPatientListComponent,
    ApplicationsPatientProfileComponent,
  ],
  imports: [MaterialModule, SharedModule, ApplicationsRouterModule, ReactiveFormsModule, CommonModule, FormsModule
  ],
  exports: [ApplicationsRouterModule],
})
export class ApplicationsModule {

}
